import { fetchContacts } from "@/services/api/apiServiceContacts";

export default {
  namespaced: true,
  state: {
    contacts: null,
    serverResponse: null,
    searchQuery: "",
    selectedContactId: null,
    isLoading: false,
    currentPage: 1,
  },
  mutations: {
    setContactChecked(state, { id, isChecked }) {
      const contactIndex = state.contacts.findIndex(
        (contact) => contact.id === id
      );
      if (contactIndex !== -1) {
        const updatedContact = {
          ...state.contacts[contactIndex],
          isChecked,
        };
        state.contacts.splice(contactIndex, 1, updatedContact);
      }
    },
    addNewContact(state, newContact) {
      state.contacts.push(newContact);
    },
    toggleAllContactsIsChecked(state, isChecked) {
      state.contacts = state.contacts.map((contact) => ({
        ...contact,
        isChecked,
      }));
    },
    setContacts(state, response) {
      if (!response || !response.data) {
        return;
      }
      state.contacts = response.data;
      state.serverResponse = response;
    },
    updateSearchQuery(state, searchQueryValue) {
      state.searchQuery = searchQueryValue;
    },
    setSelectedContactId(state, contactId) {
      state.selectedContactId = contactId;
    },
    removeContact(state, id) {
      state.contacts = state.contacts.filter((contact) => contact.id !== id);
    },
    paginationButtonClick(state, page){
      state.currentPage = page
    }
  },
  actions: {
    async getContacts({ commit, state }) {
      state.isLoading = true;
      try {
        const response = await fetchContacts(state.currentPage);
        commit("setContacts", response);
      } catch (error) {
        console.error("Failed to fetch contacts:", error);
        throw error;
      } finally {
        state.isLoading = false;
      }
    },
  },

  getters: {
    contacts: (state) => state.contacts,
    checkedContacts: (state) =>
      state.contacts?.filter((contact) => contact.isChecked),
    searchContacts: (state) => {
      if (!state.searchQuery || !state.searchQuery.trim()) {
        return state.contacts;
      }
      const lowerCaseQuery = state.searchQuery.toLowerCase();
      return state.contacts.filter(
        (contact) =>
          contact.name.toLowerCase().includes(lowerCaseQuery) ||
          contact.phone.includes(state.searchQuery)
      );
    },
    selectedContact: (state) => state.selectedContact,
  },
};
